import { z } from "zod";
import { connectIdSchema } from "../organiser";

export const updateCollaboratorSchema = z.object({
  roleId: z.string(),
  connectId: connectIdSchema,
  email: z.string().email(),
});

export const defaultUpdateCollaboratorValues = {
  role: "",
  connectId: "",
  email: "",
};

export type UpdateCollaboratorForm = z.infer<typeof updateCollaboratorSchema>;
